var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('b-table',{staticStyle:{"max-height":"1000px"},attrs:{"sticky-header":true,"items":_vm.profitData}}),_vm._v("\n      Total sum: "+_vm._s(parseFloat(_vm.profitAggr).toFixed(2))+"\n    ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }